// Central site data. Approved copy + real images can be dropped in here later.
// Placeholder strings are prefixed so they are easy to find and replace.

export const COMPANY = {
  name: "Precision Maintenance1 LLC",
  short: "Precision Maintenance",
  tagline: "Commercial Cleaning & Facility Maintenance",
  phone: "+1 800 373 2708",
  phoneHref: "tel:+18003732708",
  email: "info@pm1clean.com",
  emailHref: "mailto:info@pm1clean.com",
  website: "www.pm1clean.com",
  websiteHref: "https://www.pm1clean.com",
  address: "90 E Halsey Rd, Suite 332, Parsippany, NJ 07054",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "How We Work", path: "/how-we-work" },
  { label: "Why Precision", path: "/why-precision" },
  { label: "Client Stories", path: "/client-stories" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/77upljq2_PM1%20Clean%20Logo%20-%20PNG.png",
  // Real supplied photography
  floorMachine:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/yv34a4qr_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_53_13%20PM.png",
  corridor:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/7hfuu3la_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_41_11%20PM.png",
  moodMop:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/6081etul_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_40_50%20PM.png",
  striping:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/da7lxuz6_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_41_00%20PM.png",
  officeMop:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/njx1zzv5_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_43_26%20PM.png",
  plumbing:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/l10099n4_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_48_21%20PM.png",
  painting:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/dtlfdysn_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_41_16%20PM.png",
  carpetCare:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/0wkw8haa_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_42_45%20PM.png",
  retailScrubber:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/gfgw2afy_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_50_34%20PM.png",
  officeWetFloor:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/saqnmuz8_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_51_12%20PM.png",
  floorScrubbing:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/yv34a4qr_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_53_13%20PM.png",
  handshake:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/1yqbmom3_pexels-pnw-prod-8276364.webp",
  // Aliases used by interior pages
  heroLobby:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/njx1zzv5_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_43_26%20PM.png",
  windows:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/6081etul_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_40_50%20PM.png",
  floorSweeper:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_precision-maint/artifacts/1vx2do8a_ChatGPT%20Image%20Aug%2013%2C%202026%2C%2006_41_05%20PM.png",
};

// Sectors served — structural, tone-appropriate placeholders.
export const SECTORS = [
  "Corporate Facilities",
  "Automotive Dealerships",
  "Retail Properties",
  "Commercial Buildings",
  "Construction Projects",
  "Institutional Facilities",
];

export const SERVICES = [
  {
    id: "01",
    title: "Detailed Commercial Cleaning",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Comprehensive interior cleaning executed to a documented standard across every zone of your facility.",
    image: IMAGES.officeMop,
  },
  {
    id: "02",
    title: "Floor & Surface Care",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Hard-floor maintenance, stripping, refinishing and industrial machine sweeping for high-traffic environments.",
    image: IMAGES.floorMachine,
  },
  {
    id: "03",
    title: "Facility Maintenance",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Ongoing upkeep programs tailored to the operational rhythm of each building we service.",
    image: IMAGES.plumbing,
  },
  {
    id: "04",
    title: "Post-Construction Cleaning",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Final-phase detailing that prepares new and renovated spaces for occupancy.",
    image: IMAGES.painting,
  },
  {
    id: "05",
    title: "Window & Glass Cleaning",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Interior and accessible exterior glass programs for a consistently sharp facility appearance.",
    image: IMAGES.corridor,
  },
  {
    id: "06",
    title: "Customized Cleaning Plans",
    blurb:
      "PLACEHOLDER — Approved service description to be supplied. Scopes built line-by-line around exactly how you want your facility cleaned.",
    image: IMAGES.striping,
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Facility Walkthrough",
    body: "PLACEHOLDER — We assess your facility in person to understand its scale, traffic and the standard you expect.",
  },
  {
    no: "02",
    title: "Customized Scope",
    body: "PLACEHOLDER — We build a written scope of work around exactly how you want each area cleaned and maintained.",
  },
  {
    no: "03",
    title: "Trained Deployment",
    body: "PLACEHOLDER — A dedicated, vetted team is deployed and briefed on the specifics of your facility.",
  },
  {
    no: "04",
    title: "Quality Control",
    body: "PLACEHOLDER — Management inspects the work against the agreed standard and documents the results.",
  },
  {
    no: "05",
    title: "Responsive Accountability",
    body: "PLACEHOLDER — A direct line to management keeps the relationship accountable and responsive over the long term.",
  },
];

export const VALUES = [
  { title: "Long-Term Experience", body: "PLACEHOLDER — Value statement to be supplied." },
  { title: "Management Accountability", body: "PLACEHOLDER — Value statement to be supplied." },
  { title: "Quality Control", body: "PLACEHOLDER — Value statement to be supplied." },
  { title: "Trust & Integrity", body: "PLACEHOLDER — Value statement to be supplied." },
  { title: "Responsive Service", body: "PLACEHOLDER — Value statement to be supplied." },
  { title: "Customized Programs", body: "PLACEHOLDER — Value statement to be supplied." },
];

export const FAQS = [
  {
    q: "PLACEHOLDER — What types of facilities do you service?",
    a: "PLACEHOLDER — Approved answer to be supplied. This accordion is structured and ready for your exact wording.",
  },
  {
    q: "PLACEHOLDER — How do you ensure consistent quality?",
    a: "PLACEHOLDER — Approved answer to be supplied.",
  },
  {
    q: "PLACEHOLDER — Can cleaning plans be customized to our facility?",
    a: "PLACEHOLDER — Approved answer to be supplied.",
  },
  {
    q: "PLACEHOLDER — What is your satisfaction guarantee?",
    a: "PLACEHOLDER — Approved answer to be supplied.",
  },
  {
    q: "PLACEHOLDER — How do we request a quote or walkthrough?",
    a: "PLACEHOLDER — Approved answer to be supplied.",
  },
];

export const SERVICE_OPTIONS = [
  "Detailed Commercial Cleaning",
  "Floor & Surface Care",
  "Facility Maintenance",
  "Post-Construction Cleaning",
  "Window & Glass Cleaning",
  "Customized Program",
];

export const FACILITY_TYPES = [
  "Corporate Facility",
  "Automotive Dealership",
  "Retail Property",
  "Commercial Building",
  "Construction Project",
  "Institutional Facility",
  "Other",
];

export const FREQUENCIES = ["Daily", "Multiple times per week", "Weekly", "Monthly", "One-time / Project"];
